<template>
  <div class="qa-container container">
    <h1>付款及配送方式</h1>
    <section>
      <h2>郵資與付款說明</h2>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;郵資說明&nbsp;Postage</div>
      </div>
      <div class="text-box">
        《&nbsp;宅配&nbsp;》單筆訂單&nbsp;(&nbsp;折扣後、不含運費&nbsp;)&nbsp;
        未滿&nbsp;2000&nbsp;元者收&nbsp;70&nbsp;元，滿兩千免運&nbsp;(&nbsp;含特價品&nbsp;)。
      </div>
      <div class="text-box">
        《&nbsp;7-11&nbsp;取貨付款&nbsp;》單筆訂單&nbsp;(&nbsp;折扣後、不含運費&nbsp;)&nbsp;
        未滿&nbsp;2000&nbsp;元者收&nbsp;60&nbsp;元，滿兩千免運&nbsp; (&nbsp;含特價品&nbsp;)。
      </div>
      <div class="text-box">
        《&nbsp;宅配貨到付款&nbsp;》單筆訂單&nbsp;(&nbsp;折扣後、不含運費&nbsp;)&nbsp;
        未滿&nbsp;2000&nbsp;元者收&nbsp;100&nbsp;元，滿兩千免運&nbsp;
        (&nbsp;含特價品&nbsp;)，僅需付宅配&nbsp;30&nbsp;元之手續費。<br />
        ※&nbsp;部分外島地區無法使用貨到付款喔。
      </div>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;付款方式&nbsp;Payment</div>
      </div>
      <div class="text-box">
        1.&nbsp;《&nbsp;ATM轉帳&nbsp;/&nbsp;銀行匯款&nbsp;》
        本賣場使用綠界虛擬帳戶，請親愛的買家結帳完成，就能拿到一組專屬的虛擬帳戶、匯款至該帳戶即可，匯款後系統將會自動對帳哦！<br />
        ※&nbsp;ATM轉帳須於&nbsp;3&nbsp;天內完成付款&nbsp;(&nbsp;含當天&nbsp;)。
      </div>
      <div class="text-box">
        2.&nbsp;《&nbsp;線上刷卡&nbsp;》於結帳過程中，在付款資料<br />
        ※&nbsp;信用卡付款需於當下完成付款，若跳出頁面或刷卡失敗，訂單就會自動失效，需重新訂購唷。
      </div>
      <div class="text-box">
        3.&nbsp;《&nbsp;超商取貨付款&nbsp;/&nbsp;宅配貨到付款&nbsp;》不需事先付款，取貨時再付款。<br />
        ※&nbsp;宅配貨到付款，需額外加收代收手續費&nbsp;30&nbsp;元唷!!
      </div>
      <div class="text-box">
        <div class="part">※&nbsp;注意事項</div>
        <div class="part">
          (1)&nbsp;單筆訂單金額以折扣後實付金額為計算，滿&nbsp;2000&nbsp;元免郵&nbsp;
          (&nbsp;含特價品、貨到付款需支付&nbsp;$&nbsp;30&nbsp;手續費&nbsp;)。
        </div>
        <div class="part">
          (2)&nbsp;郵資優惠限同筆訂單一次性寄出並寄往同一處，方能享有滿額免郵優惠。
        </div>
        <div class="part">
          (3)&nbsp;
          如需分批寄出或更改品項&nbsp;/&nbsp;顏色&nbsp;/&nbsp;尺寸，需取消訂單重新訂購。原訂單享有之活動優惠，需以再次訂購之當時活動為準。
        </div>
        (4)&nbsp;郵資優惠僅針對台灣本島地區。
      </div>
    </section>
    <section>
      <h2>網路線上刷卡 Credit Card</h2>
      <div class="text-box">
        <div class="black">
          結帳過程選擇信用卡於
          <span class="main"> 【&nbsp;付款資料&nbsp;】 </span>
          輸入信用卡資訊，即可完成信用卡付款。
        </div>
      </div>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;刷卡有金額限制嗎?</div>
        單筆消費不限金額，方可使用線上刷卡服務。
      </div>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;是否只能使用特定信用卡呢?</div>
        只要可於台灣使用的信用卡都可以使用唷!!
      </div>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;線上刷卡失敗</div>
        造成刷卡失敗可能的原因有:
      </div>
      <div class="text-box">
        <div class="part">
          1.&nbsp;您的發卡銀行系統忙碌或是網路資料壅塞，刷卡等待時間過長，造成系統確認失敗。
        </div>
        解決方式&nbsp;:&nbsp;建議請過一段時間再行刷卡。
      </div>
      <div class="text-box">
        <div class="part">
          2.&nbsp;您所輸入的卡號資料不正確、卡號過期、尚未開卡或有效期限不正確..等問題。
        </div>
        解決方式&nbsp;:&nbsp;請確認卡片資訊後再次進行刷卡。
      </div>
      <div class="text-box">
        <div class="part">3.&nbsp;您的信用卡片額度已滿。</div>
        解決方式&nbsp;:&nbsp;請與發卡銀行聯繫，增加額度即可。
      </div>
      <div class="text-box">
        <div class="part">4.&nbsp;您剛繳完卡費，但銀行尚未入帳，銀行將會暫時限制線上刷卡。</div>
        解決方式&nbsp;:&nbsp;請與發卡銀行確認入帳時間完成後再進行刷卡。
      </div>
      <div class="text-box">
        <div class="part">5.&nbsp;VISA&nbsp;3D&nbsp;驗證功能失敗。</div>
        <div class="part">
          解決方式&nbsp;:&nbsp;建議您務必使用&nbsp;IE&nbsp;瀏覽器或改用&nbsp;Master&nbsp;卡等其他卡別，
          否則&nbsp;VISA&nbsp;3D&nbsp;驗證功能容易失敗。
        </div>
        使用&nbsp;VISA&nbsp;卡請先確認該發卡銀行是否已經開啟「&nbsp;Visa&nbsp;驗證&nbsp;」
        「&nbsp;3D&nbsp;SECURE&nbsp;」安全機制功能！<br />
        如您的發卡銀行已啟用 「&nbsp;Visa&nbsp;驗證&nbsp;」「&nbsp;3D&nbsp;SECURE&nbsp;」安全機制，
        而您尚未向發卡銀行索取驗證碼時，可能會造成刷卡不成功。
      </div>
      <div class="text-box">
        <div class="black">
          <i class="fas fa-heart"></i>&nbsp;刷卡失敗訂單會自動失效，再請重新訂購一次唷!!
        </div>
      </div>
    </section>
    <section>
      <h2>超商取貨</h2>
      <div class="text-box">
        <div class="black">1.&nbsp;超商取貨付款有限制嗎?&nbsp;有手續嗎?</div>
        Ans&nbsp;:&nbsp;超商取貨付款該服務不會對您多收取手續費，唯獨以下情形無法使用超商取貨&nbsp;:&nbsp;
        單筆訂單金額超過&nbsp;2&nbsp;萬元或購買體積較大&nbsp;/&nbsp;易碎品&nbsp;(&nbsp;由於體積過大&nbsp;)
        ，超商不接受使用到店取貨呦!<br />
        ※&nbsp;請特別注意！使用超商取貨請
        <span class="main">【&nbsp;填寫真實姓名&nbsp;】</span>
        ，以避免因無法核對身份、導致無法順利取件呦！
      </div>
      <div class="text-box">
        <div class="black">2.&nbsp;超商取貨付款需要郵資嗎？</div>
        Ans&nbsp;:&nbsp;需要郵資唷！超商取貨付款酌收&nbsp;60&nbsp;元費用，消費金額滿&nbsp;2000&nbsp;元&nbsp;
        (&nbsp;含&nbsp;)&nbsp;以上免運費&nbsp;(&nbsp;包含特價品&nbsp;)，詳情請參照郵資及付費說明喔！
      </div>
      <div class="text-box">
        <div class="black">3.&nbsp;超商取貨付款是先轉帳後，再去超商取貨嗎？</div>
        Ans&nbsp;:&nbsp;不用先轉帳喔！請大家特別留意這點，超商取貨付款，就是您到超商門市取貨時，再付款給店員就可以！
      </div>
      <div class="text-box">
        <div class="black">4.&nbsp;如果訂單包含要等預購的商品如何處理？</div>
        Ans&nbsp;:&nbsp;若訂單含有預購之商品，水水需接受等全部到貨後才一起寄出，
        「&nbsp;預購商品&nbsp;」若因故無法如期出貨，將先行寄出「&nbsp;現貨&nbsp;」商品！<br />
        水水們先到超商領取第一批商品&nbsp;& 付款，剩餘的商品到貨後會再行寄出喔。
      </div>
      <div class="text-box">
        <div class="black">5.&nbsp;上傳訂單後可以再更改嗎？</div>
        Ans&nbsp;:&nbsp;抱歉，訂單經確認訂購後，不可做修改異動&nbsp;
        (&nbsp;修改顏色尺寸&nbsp;/&nbsp;加購&nbsp;/&nbsp;取消單項商品&nbsp;/&nbsp;拆併單&nbsp;)
        ，如需修改訂單，請取消再重新訂購。<br />
        原訂單享有之活動優惠，需以再次訂購之當時活動為準喔。所以請務必確認您的下標訂單內容&nbsp;
        (&nbsp;明細&nbsp;&
        金額&nbsp;)&nbsp;完全正確，才能再點選「&nbsp;超商取貨付款&nbsp;」並完成訂單喔！
      </div>
      <div class="text-box">
        <div class="black">6.&nbsp;何時可以取貨呢？</div>
        <div class="part">
          Ans&nbsp;:&nbsp;商品寄出後，系統自動發送出貨通知；貨到門市會有取貨簡訊通知！
          或是您也可以自行到訂單系統查詢您的訂單，訂單的商品寄出日期加上兩天，就會到您指定的超商門市，
          商品到店後超商店家只幫買家保留&nbsp;7&nbsp;天！
        </div>
        所以請注意，一定要在期限內到店付款，若遭退回，須請您先匯款給森女，才能為您再次寄出喔。<br />
        (&nbsp;請注意&nbsp;:&nbsp;如滿兩次未到店取貨者，一律加入黑名單，之後就沒辦法再使用&nbsp;7-11&nbsp;取貨服務嚕～請愛護自己的信用)
      </div>
      <div class="text-box">
        <div class="black">7.&nbsp;超商取貨付款如何操作呢？</div>
        Ans&nbsp;:&nbsp;點選結帳後，送貨方式選擇「&nbsp;超商取貨&nbsp;」，
        付款方式選擇「&nbsp;超商取貨付款&nbsp;」，確認當次的購物商品與金額無誤後，
        填寫收件資料，並點選「&nbsp;選擇取貨門市&nbsp;」，選擇您方便領貨的超商分店即可！
      </div>
    </section>
    <section>
      <h2>宅配貨到付款 Pay on Delivery</h2>
      <div class="text-box">
        <div class="black">1.&nbsp;貨到付款有手續費嗎？</div>
        Ans&nbsp;:&nbsp;未達&nbsp;2000&nbsp;元需支付&nbsp;70&nbsp;元運費&nbsp;+&nbsp;手續費&nbsp;30&nbsp;元
        ，只要單筆消費&nbsp;2000&nbsp;元&nbsp;(&nbsp;含&nbsp;)&nbsp;以上貨到付款郵資由
        &nbsp;Snbl&nbsp;幫您負擔！您僅需負擔宅配收取之&nbsp;30&nbsp;元手續費。
      </div>
      <div class="text-box">
        <div class="black">2.&nbsp;貨到付款如何操作呢？</div>
        <div class="part">
          Ans&nbsp;:&nbsp;結帳時，選擇送貨方式點選「&nbsp;新竹物流&nbsp;」，付款方式選擇點選「&nbsp;貨到付款&nbsp;」
          ，確認購物清單與金額都無誤後。
        </div>
        <div class="part">
          (&nbsp;注意！訂單經確認訂購後，不可做修改異動，包含修改顏色尺寸&nbsp;/&nbsp;加購&nbsp;/&nbsp;
          取消單項商品&nbsp;/&nbsp;拆併單&nbsp;)
        </div>
        填寫收件住址&nbsp;/&nbsp;電話&nbsp;/&nbsp;姓名，只需等宅配服務人員，將貨品送到您指定送達地點，再將現金交予宅配服務人員即可唷！
      </div>
      <div class="text-box">
        <div class="black">3.&nbsp;貨到付款有何限制嗎？</div>
        <div class="part">
          Ans&nbsp;:&nbsp;由於每筆貨到付款的服務，宅配都會收取特定手續費用，因此貨到付款者的訂單，恕無法分批寄出喔！
          若遇商品預購須等追加到貨，將等商品到貨一起寄出，除非訂單追加超過&nbsp;14&nbsp;天者，我們會主動幫您分批寄出。
        </div>
        <div class="part">
          另外，若您指定送達地點為宅配無法配送的區域&nbsp;(&nbsp;請參閱下方清單&nbsp;)，將無法使用這項服務。
        </div>
      </div>
      <div class="text-box">
        <div class="part">※&nbsp;無法使用貨到付款的區域如下&nbsp;:<br /></div>
        馬祖地區、金門地區烏坵<br />
        台東地區之綠島及蘭嶼<br />
        澎湖地區之望安鄉、七美鄉、虎井鄉、桶盤鄉、大倉嶼、員貝嶼、 烏嶼、吉貝嶼、<br />
        烏坵鄉&nbsp;(&nbsp;大膽島、二膽島&nbsp;)
      </div>
    </section>
    <section>
      <h2>海外購物 Overseas Delivery</h2>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;海外購物流程</div>
      </div>
      <div class="text-box">
        <div class="black">1.&nbsp;點選商品【&nbsp;加入購物車&nbsp;】</div>
        <div class="part">
          於商品賣場選擇您要的顏色與尺寸，再點選【&nbsp;加入購物車&nbsp;】。<br />
        </div>
        <div class="part">
          <i class="fas fa-arrow-down"></i>
        </div>
        <div class="black">2.&nbsp;至購物車確認購買清單</div>
        <div class="part">確認購物車中的商品、顏色尺寸、金額是否正確無誤。</div>
        <div class="part">
          <i class="fas fa-arrow-down"></i>
        </div>
        <div class="black">
          3.&nbsp;送貨地點「&nbsp;選取欲配送到達的國家&nbsp;」，付款方式「&nbsp;線上刷卡&nbsp;」
        </div>
        <div class="part">
          海外購物一律採用線上刷卡付款，寄送方式為順豐快遞，【&nbsp;東南亞地區&nbsp;】運費貨到時付款給順豐司機即可。
        </div>
        <div class="part">
          運費多寡無法事先確定，視包裹實際的大小、重量而定，依順豐快遞的貨到付款費用為準，部分地區無法使用運費貨到付款者，順豐報價完，會再請北鼻下標運費，再請完成運費刷卡。
        </div>
        <div class="part">選擇配送/付款方式後，請依照結帳流程，填寫完整正確的寄送資訊。</div>
        <div class="part">
          ※&nbsp;限時特惠！國際配送此四個地區【&nbsp;香港、澳門、新加坡、馬來西亞&nbsp;】單筆訂單&nbsp;
          (&nbsp;折扣後、不含運費&nbsp;)&nbsp;未滿三千元收&nbsp;199&nbsp;元，滿三千免運&nbsp;(&nbsp;含特價品&nbsp;)&nbsp;唷！
        </div>
        <div class="part">
          ※&nbsp;請注意！香港地區如送件地址為香港非工商地區或香港偏遠地區，送件時每包需另收港幣&nbsp;$&nbsp;30&nbsp;費用。詳見可參考順豐速運。
        </div>
        <div class="part">※&nbsp;海外訂單，若遇到海關查驗產生稅金，需由買家自行負擔。</div>
        <div class="part">
          <i class="fas fa-arrow-down"></i>
        </div>
        <div class="black">4.&nbsp;點選【&nbsp;確認訂購&nbsp;】、完成訂購等待出貨囉！</div>
      </div>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;海外購物 Q & A</div>
      </div>
      <div class="text-box">
        <div class="black">1.&nbsp;付款方式只能線上刷卡嗎?</div>
        Ans&nbsp;:&nbsp;是的，為了海外購物的便利性，不管是商品或運費，一律採用線上刷卡付款喔。
      </div>
      <div class="text-box">
        <div class="black">2.&nbsp;可以用哪些方式寄送呢?</div>
        <div class="part">
          Ans&nbsp;:&nbsp;森女提供 順豐快遞 寄送服務
          <a href="http://www.sf-express.com/tw/tc/">http://www.sf-express.com/tw/tc/</a>
        </div>
        <div class="part">
          運費多寡無法事先確定，視包裹實際的大小、重量而定，依順豐快遞的貨到付款費用為準。
          部分地區無法使用運費貨到付款者，順豐報價完，會再請北鼻補刷呦!
        </div>
        <div class="part">
          ※&nbsp;限時特惠！國際配送此四個地區【&nbsp;香港、澳門、新加坡、馬來西亞&nbsp;】單筆訂單
          &nbsp;(&nbsp;折扣後、不含運費&nbsp;)&nbsp;未滿三千元收&nbsp;199&nbsp;元，
          滿三千免運&nbsp;(&nbsp;含特價品&nbsp;)&nbsp;唷！
        </div>
        ※&nbsp;請注意！香港地區如送件地址為香港非工商地區或香港偏遠地區，送件時每包需另收港幣&nbsp;$&nbsp;30&nbsp;費用。詳見可參考順豐速運。
      </div>
      <div class="text-box">
        <div class="black">3.&nbsp;海外購物可以參加免運、拆單寄現貨、或免費抽獎活動嗎?</div>
        Ans&nbsp;:&nbsp;海外寄送的成本較高，所以非常不好意思~海外訂單是無法參加免運活動的呦!<br />
        亦不適用預購超過&nbsp;14&nbsp;個工作天的拆單寄現貨、免費贈獎活動，還請北鼻見諒。
      </div>
      <div class="text-box">
        <div class="black">4.&nbsp;海外訂單可以退換貨嗎?</div>
        <div class="part">
          Ans&nbsp;:&nbsp;如果海外的北鼻們有退換需求，只要自付來回運費，同樣可享有退換貨服務呦！
          請於收到商品的&nbsp;7&nbsp;天內&nbsp;(&nbsp;包含例假日&nbsp;)&nbsp;利用網站申請售後服務。<br />
          申請流程&nbsp;>&nbsp;至會員中心&nbsp;<i class="fas fa-arrow-right"></i>&nbsp;
          消費訂單紀錄&nbsp;<i class="fas fa-arrow-right"></i>&nbsp;點選訂單明細 &nbsp;<i
            class="fas fa-arrow-right"
          ></i
          >&nbsp;按【&nbsp;申請退貨&nbsp;】。
        </div>
        ※&nbsp;注意!退貨須於&nbsp;7&nbsp;天內申請，超過&nbsp;7&nbsp;天就無法為您處理囉!
        申請後，請您在&nbsp;3&nbsp;天內寄出要退換的商品，小幫手收到後會快快為您處理喔。
        如辦理退換貨，運費不返還！
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/stylesheets/custom/_variable';

.qa-container {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;

  h1 {
    margin-bottom: 1.5rem;
    text-align: center;
    text-indent: 0.25rem;
    letter-spacing: 0.25em;
    @include font-xl;
  }

  section {
    margin-bottom: 2.5rem;

    h2 {
      margin-bottom: 1rem;
      @include font-lg;
    }

    .text-box {
      color: $gray-600;

      .black {
        margin-bottom: 0.5rem;
        font-weight: 500;
        color: $gray-900;
      }

      .part {
        margin-bottom: 0.5rem;
      }

      .main {
        font-weight: 500;
        color: $color-main;
      }

      &:not(:last-child) {
        margin-bottom: 1rem;
      }

      a {
        color: #337ab7;
      }
    }
  }
}
</style>
